export default __webpack_public_path__ + "static/media/7.09860121.png";